var getGraph;
var getResident;
var isTour = false;
var isInit = true;
var graphTypeChange = false;
var tourStep = 1;
var tourTimeout;
var isWithinMonth = true;
var mainChart;
var datatable;
var residentsTableColumns = [];
var ndx;
var removedDataNDX;
var deficienciesNDX;
var surveyNDX;
var allSurvey;
var allQIS;
var qisNDX;
var compareNDX;
var compareOtherNDX;
var compareDefNDX;
var compareDefAll;
var compareAll;
var all;
var currentResidents = [];
var outOfRangeDischages = [];
var removedResidents = [];
var changePayorResidentsOrig = [];
var outOfRangeCensusResidents = [];
var filters = {};
var subfilterClicked = {};
var removeResidentRefresh = false;
var mainDimension;
var mainGroup;
var mainGraphFilter = 'admissions';
var admissionsChart = dc.pieChart('#admissions-chart');
var dischargesChart = dc.pieChart('#discharges-chart');
var financialChart = dc.pieChart('#financial-chart');
var rawreadmissionChart = dc.pieChart('#rawreadmission-chart');
var riskadjustedChart = dc.pieChart('#riskadjusted-chart');
var physicianChart = dc.pieChart('#physicianChart-chart');
var physicianOthersChart;
var deficiencyChart;
var ftagChart;
var ftagSurveyChart;
var ftagQISChart;
var regulationChart;
var regulationSurveyChart;
var regulationQISChart;
var categoryChart;
var surveyChart;
var qisChart;
var lengthofstayChart = dc.pieChart('#lengthofstay-chart');
var lengthofstaytotalChart = dc.pieChart('#lengthofstaytotal-chart');
var losType = 'avgLOS';
var originChart = dc.pieChart('#origin-chart');
var censusChart;
var originOthersPie;
var diagnosisChart;
var compareStarPie;
var compareDefPie;

var censusData = {from: null, to: null};

var mainChartPostRenderFunction = function(){};

var dateFormat = d3.time.format('%Y-%m-%d %H:%M:%S');
var monthFormat = d3.time.format('%B %Y');
var classDateFormat = d3.time.format('%Y-%m');
var graphData;
var indicatorData;
var surveyData;
var qisData;
var compareDefData;
var nearbyRange = 'city';
var thisFacilityData = [];
var compareData = [];
var removedData = [];
var notRemovedData = [];
var removedFacilities = [];
var hmpIndex = {};
var isRemovedAdmissions = false;
var rawRate;
var adjustedRate;
var graphType = 'Bar';
var mainValueAccessor = {};

var more = '';
var haveDiagnosis = false;
var oneDay = 24*60*60*1000;
var totalIndicators = 100; //set to 100 for demo

var hospitalGeoLocations = {};

var answerValues = {
	"1": "Very Poor",
	"2": "Poor",
	"3": "Fair",
	"4": "Good",
	"5": "Very Good"
};

var deficiencyValues = {
	"A": "Isolated with No Actual Harm with Potential for Minimal Harm",
	"B": "Pattern with No Actual Harm with Potential for Minimal Harm",
	"C": "Widespread with No Actual Harm with Potential for Minimal Harm",
	"D": "Isolated with no actual harm with potential for more than minimal harm that is not immediate jeopardy",
	"E": "Pattern with no actual harm with potential for more than minimal harm that is not immediate jeopardy",
	"F": "Widespread with no actual harm with potential for more than minimal harm that is not immediate jeopardy",
	"G": "Isolated with actual harm that is not immediate jeopardy",
	"H": "Pattern with actual harm that is not immediate jeopardy",
	"I": "Widespread with actual harm that is not immediate jeopardy",
	"J": "Isolated with immediate jeopardy to resident health or safety",
	"K": "Pattern with immediate jeopardy to resident health or safety",
	"L": "Widespread with immediate jeopardy to resident health or safety"
};

var states={AL:"Alabama",AK:"Alaska",AS:"American Samoa",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",CT:"Connecticut",DE:"Delaware",DC:"District Of Columbia",FM:"Federated States Of Micronesia",FL:"Florida",GA:"Georgia",GU:"Guam",HI:"Hawaii",ID:"Idaho",IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",ME:"Maine",MH:"Marshall Islands",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",MP:"Northern Mariana Islands",OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PW:"Palau",PA:"Pennsylvania",PR:"Puerto Rico",RI:"Rhode Island",SC:"South Carolina",SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VI:"Virgin Islands",VA:"Virginia",WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"};

var compareStarRatings = [{key: 'health_inspection_rating', text: 'HEALTH INSPECTION', selected: false}, {key: 'overall_rating', text: 'OVERALL', selected: true}, {key: 'qm_rating', text: 'QUALITY MEASURES', selected: false}, {key: 'rn_staffing_rating', text: 'RN STAFFING', selected: false}];
var distanceRatings = [{key: 'city', text: 'CITY', selected: true}, {key: 'county', text: 'COUNTY', selected: false}, {key: 'state', text: 'STATE', selected: false}, {key: 'federal', text: 'FEDERAL', selected: false}];
var geographyDistance = [{key: '4', text: 'LOCAL', selected: true}, {key: 'county', text: 'COUNTY', selected: false}];

var customFilterValues = {
							lengthofstay: {
												backwards: false,
												run: function(conditionFunction){
													dc.filterAll();
													var baseConditional = function(resident, d){
														if(resident.LOS != 'Unknown' && resident.discharge_dt != 'In-house'){
															return true;
														}else{
															return false;
														}
													}
													filterMainGraph(baseConditional, conditionFunction);
												},
												check: function(checkKey){
													var filterValues = customFilterValues.lengthofstay.filters;
													for(var i = 0; i < filterValues.length; i++){
														if(filterValues[i].key == checkKey){
															var condition = filterValues[i].filterFunction(true, true);
															var isData = false;
															for(var d = 0; d < graphData.length; d++){
																if(graphData[d].LOS != 'Unknown' && graphData[d].discharge_dt != 'In-house' && condition(graphData[d])){
																	isData = true;
																	break;
																}
															};
															return isData;
														}
													}
												},
												filters:[
															{
																key: '< 10 Days',
																filterFunction: function(on, isCheck){
																	isCheck = (isCheck != undefined ? isCheck : false);
																	if(on){
																		var condition = function(resident, d){
																			if(resident.LOS < 10){
																				return true;
																			}else{
																				return false;
																			}
																		}
																		if(isCheck){
																			return condition;
																		}
																		customFilterValues.lengthofstay.run(condition);
																	}else{
																		resetMainGraph();
																	}
																}
															},
															{
																key: '10 - 20 Days',
																filterFunction: function(on, isCheck){
																	isCheck = (isCheck != undefined ? isCheck : false);
																	if(on){
																		var condition = function(resident, d){
																			if(resident.LOS >= 10 && resident.LOS <= 20){
																				return true;
																			}else{
																				return false;
																			}
																		}
																		if(isCheck){
																			return condition;
																		}
																		customFilterValues.lengthofstay.run(condition);
																	}else{
																		resetMainGraph();
																	}
																}
															},
															{
																key: '30 - 89 Days',
																filterFunction: function(on, isCheck){
																	isCheck = (isCheck != undefined ? isCheck : false);
																	if(on){
																		var condition = function(resident, d){
																			if(resident.LOS >= 30 && resident.LOS < 90){
																				return true;
																			}else{
																				return false;
																			}
																		}
																		if(isCheck){
																			return condition;
																		}
																		customFilterValues.lengthofstay.run(condition);
																	}else{
																		resetMainGraph();
																	}
																}
															},
															{
																key: '90+ Days',
																filterFunction: function(on, isCheck){
																	isCheck = (isCheck != undefined ? isCheck : false);
																	if(on){
																		var condition = function(resident, d){
																			if(resident.LOS >= 90){
																				return true;
																			}else{
																				return false;
																			}
																		}
																		if(isCheck){
																			return condition;
																		}
																		customFilterValues.lengthofstay.run(condition);
																	}else{
																		resetMainGraph();
																	}
																}
															}
														]
											},

							months: 		{
												setup: function(){
													var from = $('#from').datepicker('getDate');
													var to = $('#to').datepicker('getDate');
													var monthFilterKeys = getMonthsBetweenDates(monthFormat(from), monthFormat(to));
													var filterSets = [];
													for(var i = 0; i < monthFilterKeys.length; i++){
														var set = {};
														set.key = monthFilterKeys[i];
														set.selected = true;
														set.filterFunction = function(on, returnCondition){
															returnCondition = (returnCondition != undefined ? returnCondition : false);
															var that = this;
															if(on){
																that.selected = false;
																var condition = function(resident, d){
																	if(monthFormat(d) == that.key){
																		return false;
																	}else{
																		return true;
																	}
																}
																if(returnCondition){
																	return condition;
																}
																filterMainGraph(condition);
															}else{
																that.selected = true;
																var filters = customFilterValues.months.filters;
																var applyConditions = [];
																for(var c = 0; c < filters.length; c++){
																	if(!filters[c].selected){
																		applyConditions.push(filters[c].filterFunction(true, true));
																	}
																}
																filterMainGraph.apply('filterAll', applyConditions);
															}
														};
														filterSets.push(set);
													}
													customFilterValues.months.filters = filterSets;
												},
												backwards: true,
												filters: []
											},

							readmissions: 	{
												backwards: false,
												selected: false,
												element: $('.readmissions-select'),
												condition: function(resident, d){
													if(resident == undefined){
														return false;
													}
													if(resident.readmit == 1){
														return true;
													}else{
														return false;
													}
												},
												filter: function(on, returnCondition){
													resetMainGraph();
													if(on){
														returnCondition = (returnCondition != undefined ? returnCondition : false);
														this.selected = true;
														if(returnCondition){
															return this.condition;
														}
														filterMainGraph(this.condition);
													}else{
														this.selected = false;
													}
												}
											}
						};


var selectForTip;
var mainGraphTip;
var selectForLegend;
var bedCount;
var colors = ['#E2A82D', '#3a86b1', '#543A9D', '#2A838B', '#9682CD', '#8195CB', '#A0700B', '#A0880B', '#73BAC1', '#BE0E75', '#FFBD6D', '#88E2BB', '#FF7D49', '#E5CB43', '#7EE21F', '#E64279', '#FFDD96', '#EF7612', '#0EBF0E', '#A0002E'];
var chartLegendFunction = function(d){
	if(typeof d != 'undefined') return d.data.key;
};
var chartLegendColor = function(d){
	if(typeof d != 'undefined') return d.data.key;
};
window.originalData = {};
window.originalQISData = {};
function generateGraphs(isGraphChange, onlyFilters, currentFilters){
	if(!graphData){
		popUpMsg('No analytical data was found for the given period of time. Please select another time period');
		return;
	}
	isGraphChange = (typeof isGraphChange === 'undefined') ? false : isGraphChange;
	onlyFilters = (typeof onlyFilters === 'undefined') ? false : onlyFilters;
	currentFilters = (typeof currentFilters === 'undefined') ? {} : currentFilters;
	//remove all d3 tips
	$('.d3-tip').remove();
	if(!isGraphChange){
		formatGraphData();
	}

	var from = $('#from').datepicker('getDate');
	var to = $('#to').datepicker('getDate');

	if(mainGraphFilter === 'lengthofstay')
	{
		losType = 'avgLOS';
	}
	if(mainGraphFilter === 'lengthofstaytotal')
	{
		losType = 'los';
	}

	if(from.getMonth() == to.getMonth() && mainGraphFilter != 'lengthofstay' && mainGraphFilter != 'rawreadmission' && mainGraphFilter != 'riskadjusted' && mainGraphFilter != 'lengthofstay' && mainGraphFilter != 'lengthofstaytotal' && mainGraphFilter != 'surveys' && mainGraphFilter != 'qis'){
		isWithinMonth = true;
	}else{
		isWithinMonth = false;
	}

	//remove all listeners
	for(var i = 0; i < dc.chartRegistry.list().length; i++) {
        var chartI = dc.chartRegistry.list()[i];
        chartI.on("filtered", function(){});
    }

	dc.filterAll();

	if((removedResidents.length > 0 || removedFacilities.length > 0) && !removeResidentRefresh){
		addBackDeletedResident();
	}

	addBackData();

	if(mainGraphFilter == 'discharges'){
		isRemovedAdmissions = true;
		removeDataForDischarges();
	}else if(mainGraphFilter == 'lengthofstay' || mainGraphFilter == 'lengthofstaytotal'){
		isRemovedAdmissions = false;
		removeDataForLOS();
	}else if(mainGraphFilter != 'compare-star' && mainGraphFilter != 'census'){
		isRemovedAdmissions = false;
		removeDataForAdmissions();
	}

	if(isWithinMonth){
    	twoMonthNDX = crossfilter(graphData.concat(removedData));
	}

	var promiseRendering = function(onlyFilters){
		formatDimensions();
		disableOrDrawPies();

		if(!onlyFilters){
			drawMain();
		}

		drawPies();

	    if(removeResidentRefresh){
	    	restoreFilterData();
	    }else{
	    	getFilterOnDeleteResidentData();
	    }

		render(currentFilters);
		graphTypeChange = false;
	}

	if(mainGraphFilter == 'census' && !onlyFilters && !graphTypeChange){
		if(outOfRangeCensusResidents.length != 0){
			graphData = graphData.concat(outOfRangeCensusResidents);
		}

		popUpMsg('Loading <div class="loading-spinner">Loading...</div>');

		var fromUNIX = from.getTime() / 1000;
		var toUNIX = to.getTime() / 1000;

		var currentIDs = graphData.map(function(res){
			return parseInt(res.id);
		});

		currentIDs = currentIDs.getUnique();

		$.ajax({
			url: '/analytics/getCensus',
			async: true,
			dataType: 'json',
			method: 'POST',
			data: {currentIDs: JSON.stringify(currentIDs), from: fromUNIX, to: toUNIX},
			success: function(data){
				outOfRangeCensusResidents = data.neededResidents;
				// if((censusData.from != fromUNIX || censusData.to != toUNIX) || outOfRangeCensusResidents.length != 0){
					censusData.from = fromUNIX;
					censusData.to = toUNIX;
					to.setHours(23,59,59);
					createCensusData(data.census, to.getTime());
				// }
				promiseRendering(false);
				removePopUpAndOverlay();
			},
			error: function(err){

			}
		});
	}else{
		promiseRendering(onlyFilters);
	}
}

function formatDimensions(){
	ndx = crossfilter(graphData);
	deficienciesNDX = crossfilter(indicatorData);
	surveyNDX = crossfilter(surveyData);
	qisNDX = crossfilter(qisData);

	if(notRemovedData.length > 0){
		removedDataNDX = crossfilter(removedData.concat(notRemovedData));
	}else{
		removedDataNDX = crossfilter(removedData);
	}

	all = ndx.groupAll();
	allSurvey = surveyNDX.groupAll();
	allQIS = qisNDX.groupAll();
}

function disableOrDrawPies(){
	var diagnosisParent = $('#diagnosis-chart').parent();
	if(haveDiagnosis){
		$(diagnosisParent).find('.nodata').remove();
		diagnosisChart = dc.pieChart('#diagnosis-chart');
		getDiagnosisPie();
	}else{
		$(diagnosisParent).find('.mainFilter').data('content', 'No diagnoses data was found.');
		$(diagnosisParent).children('.filter-chart').hide();
		if(diagnosisParent.find('.nodata').length == 0){
			$('<div class="nodata">?</div>').insertBefore($(diagnosisParent).find('.menu-wrap'));
		}
		$(diagnosisParent).find('.mainFilter').addClass('noclick').css('color', '#000').show();
	}

    var censusParent = $('#census-chart').parent();
	if(bedCount != 0){
		$(censusParent).find('.nodata').remove();
		$(censusParent).children().show();
		$(censusParent).find('.sub-filters').css('display', '');
		censusChart = dc.pieChart('#census-chart');
		getCensusPie();
	}else{
		$(censusParent).find('.nodata').remove();
		$(censusParent).find('.mainFilter').data('content', 'No active bed count provided.');
		$(censusParent).children('.filter-chart').not('.edit').hide();
		if(censusParent.find('.nodata').length == 0){
			$('<div class="nodata">?</div>').insertBefore($(censusParent).find('.menu-wrap'));
		}
		$(censusParent).find('.mainFilter').addClass('noclick').css('color', '#000').show();
	}

	var deficienciesParent = $('#deficiencies-chart').parent();
	if(indicatorData.length == 0){
		$(deficienciesParent).find('.mainFilter').data('content', 'No indicator data was found.');
		$(deficienciesParent).children('.filter-chart').hide();
		if(deficienciesParent.find('.nodata').length == 0){
			$('<div class="nodata">?</div>').insertBefore($(deficienciesParent).find('.menu-wrap'));
		}
		$(deficienciesParent).find('.mainFilter').addClass('noclick').css('color', '#000').show();
	}else{
		$(deficienciesParent).children().show();
		$(deficienciesParent).find('.sub-filters').css('display', '');
		$(deficienciesParent).find('.nodata').remove();
		$(deficienciesParent).find('.mainFilter').removeClass('noclick').css('color', '#000').show();
		deficiencyChart = dc.pieChart('#deficiencies-chart');
		ftagChart = dc.pieChart('#ftag-chart');
		regulationChart = dc.pieChart('#regulation-chart');
		categoryChart = dc.pieChart('#category-chart')
		getDeficienciesPie();
	}

	var surveysParent = $('#surveys-chart').parent();
	if(surveyData.length == 0){
		$(surveysParent).find('.mainFilter').data('content', 'No survey data was found.');
		$(surveysParent).children('.filter-chart').hide();
		if(surveysParent.find('.nodata').length == 0){
			$('<div class="nodata">?</div>').insertBefore($(surveysParent).find('.menu-wrap'));
		}
		$(surveysParent).find('.mainFilter').addClass('noclick').css('color', '#000').show();
	}else{
		$(surveysParent).children().show();
		$(surveysParent).find('.sub-filters').css('display', '');
		$(surveysParent).find('.nodata').remove();
		surveyChart = dc.pieChart('#surveys-chart');
		ftagSurveyChart = dc.pieChart('#ftag-survey-chart');
		regulationSurveyChart = dc.pieChart('#regulation-survey-chart');
		$(surveysParent).find('.mainFilter').removeClass('noclick').css('color', '#000').show();
		getSurveysPie();
	}

	var qisParent = $('#qis-chart').parent();
	if(qisData.length == 0){
		$(qisParent).find('.mainFilter').data('content', 'No survey data was found.');
		$(qisParent).children('.filter-chart').hide();
		if(qisParent.find('.nodata').length == 0){
			$('<div class="nodata">?</div>').insertBefore($(qisParent).find('.menu-wrap'));
		}
		$(qisParent).find('.mainFilter').addClass('noclick').css('color', '#000').show();
	}else{
		$(qisParent).children().show();
		$(qisParent).find('.sub-filters').css('display', '');
		$(qisParent).find('.nodata').remove();
		qisChart = dc.pieChart('#qis-chart');
		$(qisParent).find('.mainFilter').removeClass('noclick').css('color', '#000').show();
		ftagQISChart = dc.pieChart('#ftag-qis-chart');
		regulationQISChart = dc.pieChart('#regulation-qis-chart');
		getQISPie();
	}

	if(compareData.length != 0){
    	createCMSPies();
    }
}

function drawMain(){
	if(dc.chartRegistry.has(mainChart)){
		var registry = dc.chartRegistry.list();
		dc.deregisterAllCharts();
		registry.splice(registry.indexOf(mainChart), 1);
		for(var i = 0; i < registry.length; i++){
			dc.registerChart(registry[i]);
		}
	}
	createMainChart();
}

function drawPies(){
	//admissions
	getAdmissionsPie();

	//discharges
    getDischargesPie();

	//financial
    getFinancialPie();

	//raw readmission
	getRawReadmissionsPie();

    //risk adjusted
    getRiskAdjustedPie();

	//length of stay
	getLengthOfStayPie();

	//length of stay
	getLengthOfStayTotalPie()

    //physician
    getPhysicianPie();

    //origin
    getOriginPie();
}

function render(currentFilters){
	dc.renderAll();

	//check if we are within the 30 day window
	var toDate = $('#to').datepicker('getDate');
	toDate = toDate.setDate(toDate.getDate() + 30);
	var today = new Date();
	today = today.setDate(today.getDate());
	var rawParent = $('#rawreadmission-chart').parent();
	var rawRates = rawreadmissionChart.group().all();
	var calculatedRawRate = 0;
	for(var i = 0; i < rawRates.length; i++){
		calculatedRawRate += rawRates[i].value.readmitPercent;
	}
	calculatedRawRate = calculatedRawRate / rawRates.length;

	var adjustedRates = riskadjustedChart.group().all();
	var calculatedAdjustedRate = 0;
	for(var i = 0; i < adjustedRates.length; i++){
		calculatedAdjustedRate += adjustedRates[i].value.riskAdjustPercent;
	}
	calculatedAdjustedRate = calculatedAdjustedRate / adjustedRates.length;

	popovers();

	setCorrectGraphInformation();

	createResidentsTable();
	
    for(var i = 0; i < dc.chartRegistry.list().length; i++) {
        var chartI = dc.chartRegistry.list()[i];
        chartI.on("filtered", wasFiltered);
        if(chartI.anchorName() in currentFilters){
        	currentFilters[chartI.anchorName()].forEach(function(d){
        		chartI.filter(d);
        	});
        }
    }
    if(!jQuery.isEmptyObject(currentFilters)){
    	dc.redrawAll();
    }
    physicianChart.group().reduceCount();
    originChart.group().reduceCount();

    removeResidentRefresh = false;
    mainChart.on('postRender', function(){
    	checkFirstTick();
    	mainChartPostRenderFunction();
    	subfilterSet();
    	generateMap();
	    if(mainGraphFilter == 'surveys'){
		    var allStacks = [];
		    if(mainChart.allGroups == undefined){
		    	mainChart.group().all().forEach(function(d){
		    		allStacks.push(d);
		    	});
		    }else{
		    	mainChart.allGroups().forEach(function(d, i){
		    	    d.all().forEach(function(a){
		    	        allStacks.push(a);
		    	    })
		    	});
		    }
		    allStacks.forEach(function(d, i){
		    	window.originalData[i] = d.value.total;
		    });
		}else if(mainGraphFilter == 'qis'){
		    var allStacks = [];
		    if(mainChart.allGroups == undefined){
		    	mainChart.group().all().forEach(function(d){
		    		allStacks.push(d);
		    	});
		    }else{
		    	mainChart.allGroups().forEach(function(d, i){
		    	    d.all().forEach(function(a){
		    	        allStacks.push(a);
		    	    })
		    	});
		    }
		    allStacks.forEach(function(d, i){
		    	window.originalQISData[i] = d.value.total;
		    });
		}
    	window.setTimeout(function(){
    		    $('#main-chart #animate').animate({
    				opacity: 0
    			}, 300, function(){
    				$('#main-chart #animate').css('display', 'none');
    			});	
    	}, 100);
    });
    mainChart.on('postRedraw', function(){
    	dc.events.trigger(function(){
    		mainChartPostRenderFunction();
    		subfilterSet();
    		if(graphType == 'Pie' || graphType == 'Doughnut'){
    			setCorrectGraphInformation();
    		}
    	}, 100);
    });
}

function generateMap(){
	if(mainGraphFilter == 'compare-star'){
		generateLocalMap();
		var bottom = $('#graphs').height() - 500 - 24;
		$('#map').css({top: bottom+'px', display: 'block'}).show();
		$('#searchForm').hide();
		$('#distanceHeading').text(($.isNumeric(nearbyRange) ? 'Local' : toTitleCase(nearbyRange))).show();
	}else{
		var bottom = $('#graphs').height() - 500 - 24;
		$('#map').css({top: bottom+'px', display: 'block'}).hide();
		$('#searchForm').show();
		$('#distanceHeading').hide();
	}
}

function checkFirstTick(onlyGet){
	onlyGet = (onlyGet != undefined ? onlyGet : false);
	var from = $('#from').datepicker('getDate');
	var to = $('#to').datepicker('getDate');
	var removeFirstTick = false;
	
	if(removeFirstTick && !onlyGet){
		$(mainChart.svg()[0]).find('.axis.x').find('.tick').eq(0).remove();
	}else if(onlyGet){
		return removeFirstTick;
	}
}
function subfilterSet(){
	if(!jQuery.isEmptyObject(subfilterClicked)){
		for(var chart in subfilterClicked){
    		if(subfilterClicked[chart].more){
				if(!subfilterClicked[chart].used){
					if(typeof subfilterClicked[chart].filter === "array"){
						subfilterClicked[chart].filter.forEach(function(d){
							window[chart].filter(d);
						});
					}else{
						window[chart].filter(subfilterClicked[chart].filter);
					}
					dc.redrawAll();
					subfilterClicked[chart].used = true;
				}else{
					if($('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+subfilterClicked[chart].filter+'"][data-chart-filter="'+subfilterClicked[chart].chart+'"]').length == 0){
						$('.filter.active').find('.sub-filters').find('a[data-trigger-filter="more"][data-chart-filter="'+subfilterClicked[chart].chart+'"]').addClass('selected');
					}
					delete subfilterClicked[chart];
				}
    		}else{
				$('.filter.active').find('.sub-filters').find('a[data-trigger-filter="'+subfilterClicked[chart].filter+'"][data-chart-filter="'+subfilterClicked[chart].chart+'"]').trigger('click');
				delete subfilterClicked[chart];
			}
		}
	}
}
function createCMSPies(){
	if(nearbyRange == 'federal' || nearbyRange == 'state'){
		if(zip !== false){
			compareData.forEach(function(d, i){
				if(('isLocal' in d) && d.isLocal){
					compareData.splice(i,1);
					if(i != 0){
						i--;
					}
				}
			});
		}
		compareOtherNDX = crossfilter(compareData)
	}else{
		if(zip !== false){
			compareData.forEach(function(d, i){
				if(('isLocal' in d) && d.isLocal){
					compareData.splice(i,1);
					if(i != 0){
						i--;
					}
				}
			});
		}
		compareNDX = crossfilter(compareData);
	}
	compareDefData = [];
	var comparestar = $('#comparestar-chart').parent();
	var compareDef = $('#comparedef-chart').parent();
	if(compareData.length == 0){
		$(comparestar, compareDef).find('.mainFilter').data('content', 'No Facilities were found near you.');
		$(comparestar, compareDef).children('.filter-chart').hide();
		if(comparestar.find('.nodata').length == 0){
			$('<div class="nodata allowHover">?</div>').insertBefore($(comparestar).find('.menu-wrap'));
		}
		if(compareDef.find('.nodata').length == 0){
			$('<div class="nodata allowHover">?</div>').insertBefore($(compareDef).find('.menu-wrap'));
		}
		if(zip === false){
			$(comparestar, compareDef).find('.mainFilter').addClass('noclick').css('color', '#000').show();
		}
	}else{
		$(comparestar, compareDef).children().show();
		$(comparestar, compareDef).find('.sub-filters').css('display', '');
		$(comparestar, compareDef).find('.nodata').remove();
		$(comparestar, compareDef).find('.mainFilter').removeClass('noclick').css('color', '#000').show();
		compareStarPie = dc.pieChart('#comparestar-chart');
		//compareDefPie = dc.pieChart('#comparedef-chart');
		getCompareStarPie();
		//getCompareDefPie();
		compareStarPie.render();
		//compareDefPie.render();
	}

	compareAll = compareNDX.groupAll();
}